import { graphql } from '@apollo/client/react/hoc'

import getCountry from '../../helpers/get-country'
import { ApplicationError, NotFoundError } from '../../helpers/errors'
import { parseCentreBannerHours } from '../../helpers/parse-opening-hours'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ match, staticContext }) => {
  const country = getCountry(staticContext)

  return {
    variables: {
      slugQuery: `fields.slug[match]=${match.params.centre}&fields.country=${country}`,
    },
    errorPolicy: 'ignore',
  }
}

export const mapDataToProps = ({ data: { error, loading, centres } }) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!centres[0]) {
    // Centre is not known
    return {
      error: new NotFoundError(),
    }
  }

  const centre = {
    ...centres[0],
    tradingHours: { ...centres[0].centreTradingSchedule }.tradingHours,
    bespoke: {
      luxury: centres[0].themeColour === 'Minimal',
      deckBG:
        (centres[0].deckBackground && centres[0].deckBackground.url) || '',
    },
  }
  const contactLinks = [
    'facebook',
    'twitter',
    'instagram',
    'youtube',
  ].map(social => ({ type: social, url: centre[social] }))
  const features = centre.features || []
  const navigationData = JSON.parse(centre.navigationMenu)
  const centreBanner = parseCentreBannerHours(
    centre.tradingHours || [],
    centre.timeZone,
    features
  )
  if (centre.status === 'Open') {
    return {
      centre: {
        ...centre,
        navigationMenu: Array.isArray(navigationData) ? navigationData : null,
        contactLinks,
        centreBanner,
      },
    }
  } else if (centre.status === 'Opening Soon') {
    return {
      centre: {
        ...centre,
        navigationMenu: Array.isArray(navigationData) ? navigationData : null,
        contactLinks,
      },
    }
  } else {
    return {
      centre: {
        ...centre,
        utilityBoxRetailerCategories: null,
        navigationMenu: null,
        contactLinks,
        centreBanner,
      },
    }
  }
}

const withCentre = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withCentre
